import React from 'react';
import Form from '../../common/masterform/Form';
import formConfig from './formConfig';

export default function SimulationInstanceOverview() {
    return <Form formId="simulation-instance" config={formConfig}/>;
}
